import client from "../../../../utils/connected/api";
import {getUrl} from "../../../../utils";

export const getCredentialsTypesRequest = (filterParams) => client.get(getUrl("credentials-types", filterParams));

export const createCredentialsTypesRequest = (data) => client.post("credentials-types", data);

export const deleteCredentialsTypesRequest = (code) => client.delete(`credentials-type/${code}`);

export const editCredentialsTypesRequest = (data) => client.put(`credentials-type/${data.code}`, data);
